import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { AdminStatisticsCardElement } from "../components/AdminStatisticsCardElement";
import { Col, Container, Row, Card } from "react-bootstrap";
import SvgConstructOrangeRibbonCert from "../assets/SvgConstructOrangeRibbonCert";
import SvgConstructPurpleMugShot from "../assets/SvgConstructPurpleMugShot";
import { AxisLineSeparator } from "../components/AxisLineSeparator";
import { AdminExternalLinkElement } from "../components/AdminExternalLinkElement";
import Button from "react-bootstrap/Button";
import { AxisClock } from "../util/AxisDateTime";
import { PageTitleController } from "../components/PageTitleController";
import { BsHouseFill, BsQuestionCircle, BsCalendarCheck } from "react-icons/bs";

const AdminOverview = () => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    fetch();
    document.title = "Axis Healthcare";
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);

      const resp = await authAxios().get("/api/backoffice/overview/");
      setOverview(resp.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };


  const StatsSpinnerOrData = (loading) => {
    return (
      <Fragment>
        <div className="axis-card-container mb-4">
          
          {/* Certification Section */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h6 className="mb-0">Certifications</h6>
            </Card.Header>
            <Card.Body>
              <Row xs={1} md={2} className="g-3">
                {AdminStatisticsCardElement(
                  "Expired Certificates",
                  "/api/backoffice/overview/expired_certs",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/nurse-certificates",
                  { redirectKey: "expired-certs" },
                )}
                {AdminStatisticsCardElement(
                  "Access NI Expiring (30 Days)",
                  "/api/backoffice/overview/accessni_expiring_30_days",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/nurse-certificates",
                  { redirectKey: "expiring-30-certs" },
                )}
              </Row>
            </Card.Body>
          </Card>
          
          {/* Shifts Summary Section */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h6 className="mb-0">Shift Status Overview</h6>
            </Card.Header>
            <Card.Body>
              <Row xs={1} md={3} lg={3} className="g-3">
                {AdminStatisticsCardElement(
                  "Open Shifts",
                  "/api/backoffice/overview/open_shifts",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/shifts",
                  { redirectKey: "OPEN" },
                )}
                {AdminStatisticsCardElement(
                  "Pending Shifts",
                  "/api/backoffice/overview/pending_shifts",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/shifts",
                  { redirectKey: "PENDING" },
                )}
                {AdminStatisticsCardElement(
                  "Confirmed Shifts",
                  "/api/backoffice/overview/confirmed_shifts",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/shifts",
                  { redirectKey: "CONFIRMED" },
                )}
              </Row>
            </Card.Body>
          </Card>
          
          {/* Timesheets Section */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h6 className="mb-0">Weekly Timesheet Status</h6>
            </Card.Header>
            <Card.Body>
              <Row xs={1} md={2} lg={3} className="g-3">
                {AdminStatisticsCardElement(
                  "Missing Timesheets",
                  "/api/backoffice/overview/timesheets_missing_for_this_week",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/timesheets",
                  { redirectKey: "MISSING" },
                )}
                {AdminStatisticsCardElement(
                  "Pending Timesheets",
                  "/api/backoffice/overview/timesheets_pending_for_this_week",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/timesheets",
                  { redirectKey: "PENDING" },
                )}
                {AdminStatisticsCardElement(
                  "Rejected Timesheets",
                  "/api/backoffice/overview/timesheets_rejected_for_this_week",
                  <SvgConstructOrangeRibbonCert floatType={"right"} />,
                  "/timesheets",
                  { redirectKey: "REJECTED" },
                )}
                {/*{AdminStatisticsCardElement(*/}
                {/*  "Approved timesheets for this week",*/}
                {/*  "/api/backoffice/overview/timesheets_approved_for_this_week",*/}
                {/*  <SvgConstructOrangeRibbonCert floatType={"right"} />,*/}
                {/*  "/timesheets",*/}
                {/*  { redirectKey: "APPROVED" },*/}
                {/*)}*/}
              </Row>
            </Card.Body>
          </Card>
          
          {/* User Status Section */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h6 className="mb-0">User Status</h6>
            </Card.Header>
            <Card.Body>
              <Row xs={1} md={2} lg={3} className="g-3">
                {AdminStatisticsCardElement(
                  "New Staff This Month",
                  "/api/backoffice/overview/new_staff_this_month",
                  <SvgConstructPurpleMugShot floatType={"right"} />,
                  "/users",
                )}
                {AdminStatisticsCardElement(
                  "Nurses Using App",
                  "/api/backoffice/overview/users_on_app",
                  <SvgConstructPurpleMugShot floatType={"right"} />,
                  "/users",
                )}
                {AdminStatisticsCardElement(
                  "Nurses Not Using App",
                  "/api/backoffice/overview/users_not_on_app",
                  <SvgConstructPurpleMugShot floatType={"right"} />,
                  "/users",
                )}
                {AdminStatisticsCardElement(
                  "Users On Hold",
                  "/api/backoffice/overview/users_on_hold",
                  <SvgConstructPurpleMugShot floatType={"right"} />,
                  "/users",
                  { redirectKey: "HOLD" },
                )}
                {AdminStatisticsCardElement(
                  "Users Blocked",
                  "/api/backoffice/overview/users_blocked",
                  <SvgConstructPurpleMugShot floatType={"right"} />,
                  "/users",
                  { redirectKey: "BLOCKED" },
                )}
                {AdminStatisticsCardElement(
                  "Users With Availability Today",
                  "/api/backoffice/stats/users_with_availability_today",
                  <BsCalendarCheck size={50} className="float-end text-primary" />,
                  "/statistics",
                )}
              </Row>
            </Card.Body>
          </Card>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Row className="mb-4">
        <Col lg={6}>
          <PageTitleController
            title={"Dashboard"}
            icon={<BsHouseFill className={"icon-right-spacing"} />}
          />
          <h3 className={"text-axis-gray mt-2"}>
            Hi there,{" "}
            <span className={"text-capitalize"}>{overview?.forename}</span>.
          </h3>
        </Col>
        <Col lg={6}>
          <Row className={"justify-content-end align-items-center"}>
            <Col xs="auto" className={"text-axis-offblack fs-5"}>
              {AxisClock()}
            </Col>
          </Row>
        </Col>
      </Row>

      <Card className="shadow-sm mb-4">
        <Card.Header className="bg-light d-flex justify-content-between align-items-center">
          <h5 className="text-axis-offblack mb-0">Allocate Links</h5>
        </Card.Header>
        <Card.Body>
          <Row xs={1} md={2} lg={5} className="g-3">
            {AdminExternalLinkElement()}
          </Row>
        </Card.Body>
      </Card>

      <div>{StatsSpinnerOrData(loading)}</div>
    </Fragment>
  );
};

export default AdminOverview;
